export const Types = {
  SAVE_LIST_POPUP: 'SAVE_LIST_POPUP',
  SAVE_SETTING: 'SAVE_SETTING',
  SAVE_LIST_SCREEN_BANNER: 'SAVE_LIST_SCREEN_BANNER',
  SAVE_LIST_BANNER_HOMEPAGE: 'SAVE_LIST_BANNER_HOMEPAGE',
}
